import { EQuizStatsDateInterval } from '@constants';
import { IQuizEvolutionData, IQuizResultsEvolutionByDateRange } from '@sdk/contracts';
import { dateProvider } from '@utils';

export const transformQuizResponseForGraph = (
  results: IQuizResultsEvolutionByDateRange[],
  groupBy: EQuizStatsDateInterval,
  timezone = 'Europe/Madrid'
): IQuizEvolutionData => {
  const labels: string[] = [];
  const correct: number[] = [];
  const wrong: number[] = [];
  const blank: number[] = [];
  const language = localStorage.getItem('i18nextLng') || 'es';

  results?.forEach(item => {
    const start = new Date(item._id.period);
    const label = buildLabel(start, groupBy, timezone, language);

    labels.push(label);
    correct.push((item.totalCorrectResponses / item.totalAnswers) * 100);
    wrong.push((item.totalWrongResponses / item.totalAnswers) * 100);
    blank.push((item.totalBlankResponses / item.totalAnswers) * 100);
  });

  return {
    labels,
    correct,
    wrong,
    blank
  };
};

const buildLabel = (
  start: Date,
  groupBy: EQuizStatsDateInterval,
  timezone: string,
  language: string
): string => {
  const startDate = dateProvider.utcToZonedTime(start, timezone);
  let endDate = startDate;

  switch (groupBy) {
    case 'day':
      return `${startDate.getDate()} ${dateProvider.monthName(startDate.getMonth(), language)}`;
    case 'week':
      endDate = dateProvider.add(startDate, 6, 'days');
      break;
    case 'month':
      return `${dateProvider.monthName(startDate.getMonth(), language)} ${startDate.getFullYear()}`;
  }

  return `${startDate.getDate()} ${dateProvider.monthName(
    startDate.getMonth(),
    language
  )} - ${endDate.getDate()} ${dateProvider.monthName(endDate.getMonth(), language)}`;
};
